module.exports = __webpack_public_path__ + "img/7.820f2c61.jpg";